export function authRedirectRules() {
  const path = window.location.pathname
  const notAllowedRoutes = ['login', 'logout', 'profile-selector'].some(item => path.includes(item))
  const urlQueryParams = new URLSearchParams(window.location.search)
  const isROOT = (urlQueryParams.get('from') === '/') || (path === '/')

  return {
    path,
    urlQueryParams,
    isROOT,
    notAllowedRoutes,
  }
}
